import { DialogContent } from "./DialogContent";
import { DialogTrigger } from "./DialogTrigger";

const RecordCard = {
	Trigger: DialogTrigger,
	Content: DialogContent,
};

export default RecordCard;
